import React, { useState } from 'react';
import { Modal, NamedLink } from '../../components';
import css from './CompleteProfileModal.module.css';

const CompleteProfileModal = (props) => {
    const {
        onManageDisableScrolling,
        variant,
    } = props;

    const [isOpen, setIsOpen] = useState(true);

    return <Modal
        id="CompleteProfileModal"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        hideCloseBtn={true}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
    >
        <div className={css.root}>
            <div>
                {variant == "Inquiry" ? "In order to enquire, please finish updating your profile settings." : "To create a listing, please finish updating updating your profile settings. "}
            </div>

            <NamedLink
                name="ProfileSettingsPage"
                className={css.mainLink}
            >
                Profile settings
            </NamedLink>
        </div>
    </Modal>
};

export default CompleteProfileModal;
